export default [
    {
        path: '/eocs',
        name: 'eocs',
        component: () => import("@/views/eocs/index.vue"),
        meta: {
            title: '对接问需'
        }
    }, {
        path: '/wsdxs',
        name: 'wsdxs',
        component: () => import("@/views/eocs/wsdxs/index.vue"),
        meta: {
            title: '我是未就业大学生'
        }
    },
    {
        path: '/wsdxs-push-result',
        name: 'wsdxs-push-result',
        component: () => import("@/views/eocs/wsdxs/result/push-result.vue"),
        meta: {
            title: '未就业大学生岗位推送结果'
        }
    },
    {
        path: '/wsdxs-count-result',
        name: 'wsdxs-count-result',
        component: () => import("@/views/eocs/wsdxs/result/count-result.vue"),
        meta: {
            title: '未就业大学生岗位计算结果'
        }
    },
    {
        path: '/wslxs',
        name: 'wslxs',
        component: () => import("@/views/eocs/wslxs/index.vue"),
        meta: {
            title: '我是海外留学生'
        },
    },
    {
        path: '/wslxs-push-result',
        name: 'wslxs-push-result',
        component: () => import("@/views/eocs/wslxs/result/push-result.vue"),
        meta: {
            title: '海外留学生岗位推送结果'
        }
    },
    {
        path: '/wslxs-count-result',
        name: 'wslxs-count-result',
        component: () => import("@/views/eocs/wslxs/result/count-result.vue"),
        meta: {
            title: '海外留学生岗位计算结果'
        }
    },
    {
        path: '/sydcb',
        name: 'sydcb',
        component: () => import("@/views/eocs/sydcb/sydcb.vue"),
        meta: {
            title: '“宁就业”求职匹配小程序'
        },
    },
    {
        path: '/sydcb-push-result',
        name: 'sydcb-push-result',
        component: () => import("@/views/eocs/sydcb/result/push-result.vue"),
        meta: {
            title: '失业岗位推送结果'
        }
    },
    {
        path: '/sydcb-count-result',
        name: 'sydcb-count-result',
        component: () => import("@/views/eocs/sydcb/result/count-result.vue"),
        meta: {
            title: '失业岗位计算结果'
        }
    },
    // 通用岗位详情
    {
        path: '/job-view',
        name: 'job-view',
        component: () => import("@/views/eocs/result/view.vue"),
        meta: {
            title: '岗位详情'
        }
    },
    //通用岗位推送结果
    {
        path: '/push-result',
        name: 'push-result',
        component: () => import("@/views/eocs/result/push-result.vue"),
        meta: {
            title: '岗位推送结果'
        }
    },
    //通用岗位计算结果
    {
        path: '/count-result',
        name: 'count-result',
        component: () => import("@/views/eocs/result/count-result.vue"),
        meta: {
            title: '岗位计算结果'
        }
    },
    //大学生调查问卷（旧的页面改的）
    {
        path: '/dxsdcwj',
        name: 'dxsdcwj',
        component: () => import("@/views/eocs/dxsdcwj/dxsdcwj.vue"),
        meta: {
            title: '大学生调查'
        }
    },
    {
        path: '/questionnaireAppnew',
        name: 'questionnaireAppnew',
        component: () => import("@/views/eocs/dxsdcwjfornj/对接南京大学生版中转.vue"),
        meta: {
            title: '对接问需'
        }
    },
    {
        path: '/dxsdcwjfornj',
        name: 'dxsdcwjfornj',
        component: () => import("@/views/eocs/dxsdcwjfornj/dxsdcwjfornj.vue"),
        meta: {
            title: '大学生调查'
        }
    },
    //大学生调查问卷岗位推送结果（旧的页面改的）
    {
        path: '/dxsdcwj-push-result',
        name: 'dxsdcwj-push-result',
        component: () => import("@/views/eocs/dxsdcwj/dxsdcwj-push-result.vue"),
        meta: {
            title: '岗位推送结果'
        }
    },
    //大学生调查问卷岗位计算结果（旧的页面改的）
    {
        path: '/dxsdcwj-count-result',
        name: 'dxsdcwj-count-result',
        component: () => import("@/views/eocs/dxsdcwj/dxsdcwj-count-result.vue"),
        meta: {
            title: '岗位计算结果'
        }
    },
    {
        path: '/upgrade',
        name: 'upgrade',
        component: () => import("@/views/eocs/upgrade.vue"),
        
    },
    {
        path: '/ljhzp',
        name: 'ljhzp',
        component: () => import("@/views/eocs/ljhzp/index.vue"),
        meta: {
            title: '留交会招聘'
        }
    },
    {
        path: '/ljhzp-result',
        name: 'ljhzp-result',
        component: () => import("@/views/eocs/ljhzp/result/result.vue"),
        meta: {
            title: '留交会招聘结果'
        }
    }
]


// WEBPACK FOOTER //
// ./src/views/eocs/router.js